import { MAP_TYPES } from '@deck.gl/carto';

const COUNTIES_BY_COUNTY_IDS_SOURCE_ID = 'countiesByCountyIdsSource';

function source(countyIds, year, socioeconomicFactors = []) {
  let whereClause = '';

  year = parseInt(year);

  countyIds.forEach((countyId, index) => {
    let countyIdSplitted = countyId.split(',');

    let stateName = countyIdSplitted?.[1]?.trim() || '';
    let countyName = countyIdSplitted?.[0]?.trim() || '';

    if (index === 0) {
      whereClause += 'WHERE (';
    }
    whereClause += `observations.StateName ="${stateName}" AND observations.CountyName ="${countyName}"`;
    if (index < countyIds.length - 1) {
      whereClause += ' OR ';
    } else {
      whereClause += ')';
    }
  });

  whereClause += ` AND observations.year = ${year}`;

  let socioeconomicFactorsParsed =
    socioeconomicFactors.length > 0 ? `, ${socioeconomicFactors.join(', ')}` : '';

  return {
    id: COUNTIES_BY_COUNTY_IDS_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT
        ST_X(ST_CENTROID(geom)) AS lng, ST_Y(ST_CENTROID(geom)) AS lat, broadband, year, geom, geometry.countyname AS countyname, geometry.statename AS statename, "county" AS type ${socioeconomicFactorsParsed}
      FROM
        carto-dw-ac-cn5bemsi.shared.county_observations AS observations
      JOIN
        carto-dw-ac-cn5bemsi.shared.county_geometries AS geometry ON observations.CountyName = geometry.countyname AND observations.StateName = geometry.statename
      ${whereClause}
    `,
    queryParameters: {
      countyIds,
      year,
    },
  };
}

export default source;
